import {Component, OnInit, OnDestroy} from '@angular/core';
import {Constants} from 'config/constants';

@Component({
    selector: 'tpc-individual-calculator',
    templateUrl: './individual-calculator.component.html',
    styleUrls: ['./individual-calculator.component.css']
})
export class IndividualCalculatorComponent implements OnInit, OnDestroy {
    public calculatorName: string = Constants.calculators.individual;
    public menuItems: Array<any> = [
        {
            name: 'vehicle',
            title: 'Vehicle',
            url: '/individual/vehicle',
            checked: false
        },
        {
            name: 'transit',
            title: 'Public Transit',
            url: '/individual/transit',
            checked: false
        },
        {
            name: 'travel',
            title: 'Air Travel',
            url: '/individual/travel',
            checked: false
        },
        {
            name: 'home',
            title: 'Home Energy',
            url: '/individual/home',
            checked: false
        },
    ];

    constructor() {
    }

    ngOnInit() {
    }

    ngOnDestroy () {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-calculator.component.ts